import { clsx } from 'clsx';

import { SurveyRow } from './SurveyRow';
import { SurveyAddRow } from './SurveyAddRow';
import cls from './Survey.module.css';


export type SurveyQuestionType = '1-5' | 'yes-no' | 'text' | 'options';

export interface OptionItemProps {
  value: string | null;
  label: string;
  idx: string;
}

export interface CxSurveyQuestionProps {
  answer: string | null;
  answeredByUser: boolean;
  category: string;
  id: number | null;
  isEnabled: boolean;
  isRequired: boolean;
  name: string;
  nameClient: string;
  options: OptionItemProps[] | null;
  position: number;
  type: SurveyQuestionType;
  idx: string;
  isSelected: boolean;
}

interface Props {
  category: string;
  list: CxSurveyQuestionProps[];
  setList: (questions: CxSurveyQuestionProps[]) => void;
  hasAlterName?: boolean;
  hasNewRow: boolean;
  setHasNewRow: (flag: boolean) => void;
  maxLength: number;
  hasMultiple?: boolean;
}

export const Survey = (
  { category, list, setList, hasAlterName, hasNewRow, setHasNewRow, maxLength, hasMultiple }: Props,
) => {
  return (
    <div className={cls.wrap}>
      <div className={cls.table}>
        <div className={cls.thead}>
          <div className={cls.tr}>
            <div className={clsx(cls.th, cls.thCheck)}/>
            <div className={clsx(cls.th, cls.thPosition)}>Position</div>
            <div className={clsx(cls.th, cls.thQuestionCx)}>CX Question</div>
            {hasAlterName
              ? <div className={clsx(cls.th, cls.thQuestionSurvey)}>Survey Question</div>
              : null}
            <div className={clsx(cls.th, cls.thType)}>Type</div>
            <div className={clsx(cls.th, cls.thRequired)}>*</div>
          </div>
        </div>
        <div className={cls.tbody}>
          {list.length ? list.map((item) => (
            <SurveyRow
              key={item.idx}
              hasAlterName={hasAlterName}
              list={list}
              item={item}
              setList={setList}
              hasNewRow={hasNewRow}
              setHasNewRow={setHasNewRow}
              hasMultiple={hasMultiple}
            />
          )) : null}
        </div>
      </div>
      {!list.length ? <div className={cls.emptyRow}>Questions list is empty...</div> : null}
      <SurveyAddRow
        hasAlterName={hasAlterName}
        list={list}
        setList={setList}
        category={category}
        hasNewRow={hasNewRow}
        setHasNewRow={setHasNewRow}
        maxLength={maxLength}
      />
    </div>
  );
};
